import { ProblemDetails } from "../../../api";

export const isProblemDetails = <T extends object>(v: T | ProblemDetails): v is ProblemDetails => {
    return 'detail' in v && 'type' in v;
}